// extracted by mini-css-extract-plugin
export default {"table":"ViewProducts_table__Fjz5B","search":"ViewProducts_search__Rd5BL","icons":"ViewProducts_icons__HmbVS"};